<template>
  <div>
    <v-row class="mt-1 mr-2" align="center" @click="showInfo = !showInfo">
      <v-col cols="1">
        <v-icon class="mr-2" size="20" :color="isConnected ? 'green' : 'grey'"
          >mdi-propane-tank</v-icon
        >
      </v-col>
      <v-col cols="7">
        <span class="text-h6 font-weight-light">{{ tank.nome }} </span>
      </v-col>
      <v-col cols="4" class="d-flex justify-end">
        <span style="font-size: 20px; font-weight: 300">{{
          isConnected
            ? tank.volume_liquido
              ? tank.volume_liquido.toFixed(0) + " Lit."
              : "N/A"
            : "N/A"
        }}</span>
      </v-col>
    </v-row>
    <template v-if="showInfo">
      <v-row no-gutters class="mt-4">
        <v-col cols="11" offset="1">
          <template v-if="!isConnected">
            <span class="grey--text text--lighten-1"
              >Disconnesso ({{ last_update }})</span
            >
          </template>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="10" offset="1">
          <v-progress-linear
            :value="isConnected ? percentuale_riemp : 0"
            height="20"
            color="indigo"
          >
            <span class="white--text"
              ><strong
                >{{
                  isConnected ? percentuale_riemp.toFixed(0) : "N/A"
                }}
                %</strong
              ></span
            >
          </v-progress-linear>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-2">
        <v-col cols="11" offset="1">
          <span class="grey--text">Capacità:</span
          >{{ capacit.toFixed(0) }} Litri
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="11" offset="1">
          <span class="grey--text">Altezza Liquido:</span>
          <span>
            {{ isConnected ? tank.altezza_liquido.toFixed(0) + " cm" : "N/A" }}
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="11" offset="1">
          <span class="grey--text">Temperatura:</span>
          <span>
            {{
              isConnected
                ? tank.temp_lettura
                  ? tank.temp_lettura.toFixed(1) + " °C"
                  : "N/A"
                : "N/A"
            }}
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="11" offset="1">
          <v-btn outlined small color="green" @click="read_request"
            ><v-icon left>mdi-refresh</v-icon>Richiesta Lettura</v-btn
          >
          <v-snackbar
            v-model="snackbar_richiesta"
            :timeout="3000"
            bottom
            color="green"
          >
            <v-icon left>mdi-information</v-icon>
            Richiesta di lettura inviata
          </v-snackbar>
        </v-col>
      </v-row>
    </template>
    <v-divider class="mt-4" />
  </div>
</template>

<script>
import tank_el_mixin from "../mixin/tank_element_mixin";
export default {
  mixins: [tank_el_mixin],
  data() {
    return {
      showInfo: false,
    };
  },
};
</script>